import RoleAccessProviderContainer from "./RoleAccessProviderContainer";

export { 
    RoleAccessProviderContainer as RoleAccessProvider
};